import { z } from 'zod';
/**
 * Đàm phán phạm vi — APM-AI-u (`plan-ai-features.md` mục 5).
 *
 * PM nhập một ràng buộc mới ("phải bàn giao sớm hai tuần") và nhận về vài
 * **phương án**, mỗi phương án kèm ngày kết thúc mới đã mô phỏng. Không phải một
 * lời khuyên — một bảng so sánh để họ chọn, vì việc cắt cái gì là quyết định của
 * người chịu trách nhiệm, không phải của model.
 */
export const ScopeOption = z.object({
    name: z.string().min(1).max(120),
    /** Việc đề nghị **bỏ hẳn**. */
    cuts: z.array(z.uuid()).max(50),
    /** Việc đề nghị **hoãn** sang sau mốc. */
    defers: z.array(z.uuid()).max(50),
    /** Ngày kết thúc mới, tính bằng số ngày từ mốc mô phỏng. Lấy từ `run_simulation`. */
    p50Days: z.number(),
    p85Days: z.number(),
    /** Objective bị ảnh hưởng và ảnh hưởng thế nào — phần đắt nhất của mỗi phương án. */
    objectivesHit: z
        .array(z.object({ objectiveId: z.uuid(), impact: z.string().min(1).max(300) }))
        .max(10),
    /** Rủi ro đang mở mà phương án này đụng tới (vd cắt đúng việc đang giảm thiểu nó). */
    risksTouched: z.array(z.uuid()).max(10),
});
export const ScopeNegotiation = z.object({
    /** Ràng buộc PM đưa ra, chép lại để bản nháp tự đủ nghĩa. */
    constraint: z.string().min(1).max(500),
    options: z.array(ScopeOption).min(1).max(5),
    /** Chỉ số phương án đề xuất trong `options`. */
    recommended: z.number().int().nonnegative(),
    rationale: z.string().min(1).max(2_000),
});
//# sourceMappingURL=ai-scope.js.map